/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    declare var joint: any;

    export class ConfigurationModel {

        public navigation: ProcessNavigationModel;
        public processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        public processType: Wars.Domain.Model.ProcessType;

        constructor(
            public id: string,
            section: string,
            processConfigurationService: services.ProcessConfigurationService,
            processTypeService: services.ProcessTypeService)
        {
            processConfigurationService.getProcessConfigurationWithForms(id).then(processConfig => {
                this.processConfiguration = processConfig;
                processTypeService.getProcessTypeById(this.processConfiguration.processType_id).then((processType) => this.processType = processType);
            });

            this.navigation = new models.ProcessNavigationModel(section);
        }

    }
}